import GetApi from '../../../common/api/get'

export function setState(params) {
  return {
    type: 'SET_STATE_AMENITIES',
    params: params
  }
}

export function get() {
  return async (dispatch, getState) => {
    const getApi = new GetApi()
    await getApi.execute(routeUrlHelper.classificationsAmenitiesPath(), '').then((res) => {
      dispatch(setState({ amenities_list: res.body.amenities_list }))
      return true
    }, (res) => {
      dispatch(setState({ error: { main: 'An error occurred' } }))
      return false
    })
  }
}
